<template>
<!-- :style="info != null && info.is_buy==1 && pay_status != 2 ? 'padding-bottom:3rem' : 'padding-bottom:1.5rem'" -->
<div :class="showSettle ? 'page page_dingzhi page_dingzhiDetail public page_limit' : 'page page_dingzhi page_dingzhiDetail public'" :style="pinglun_status ? 'padding-bottom:3rem': 'padding-bottom:1.5rem'">
    <div class="banner" v-if="info && info.attrShow">
		<van-swipe class="my-swipe detail_swipe" :autoplay="bannerTime">
            <van-swipe-item :show-indicators="false" :loop="false" v-if="info.video_type==0&&info.other_video_url">
				<div class="prism-player video_play" :id="playerId" :style="playStyle"></div>
			</van-swipe-item>
            <van-swipe-item :show-indicators="false" :loop="false" v-else-if="info.video_type==1&&info.video_url">
				<div class="prism-player video_play" :id="playerId" :style="playStyle"></div>
			</van-swipe-item>
			<van-swipe-item :show-indicators="false" :loop="false" v-for="(img,index) in info.attrShow" :key="index">
				<van-image fit="contain" class="banner_tu" :show-error="false" :show-loading="false" :src="imageUrl+img" />
			</van-swipe-item>
		</van-swipe>
	</div>
    
	<div class="dingzhi_nr" v-if="info != null">
		<div class="title">{{ info.title }}</div>
        <div class="price_hua" v-if="info.is_buy==1&&info.underline_price">
            <div class="price_yuan">原价:¥{{ info.underline_price }}</div>
            <div class="price_zun">尊享价:¥<span class="jiage">{{ info.userprice ? info.userprice : info.price }}</span></div>
        </div>    
        <div class="price" v-else-if="info.is_buy==1">价格:¥<span class="jiage">{{ info.userprice ? info.userprice : info.price }}</span></div>
		<div class="price" v-else>价格:¥<span class="jiage">{{ info.price_range }}</span></div>
		<div class="desc">{{ info.descript }}</div>
		<div class="tips" v-if="info.totalCount>0">
			<div class="tip">已定制</div>
			<div class="prowrap">
				<van-progress :percentage="info.percentage>0?info.percentage:0" :pivot-text="(info.hadMadeCount>0?info.hadMadeCount:0)+'件'" color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
				<div class="percent">{{info.percentage>0?info.percentage:0}}%</div>
			</div>
		</div>
	</div>
	<div class="dingzhi_time" v-if="info">
		<div class="times">
			<div class="time" v-if="info.end_at">
				<div class="time_t">{{ info.timeLeft ? info.timeLeft : info.end_at }}</div>
				<div class="time_b">{{ info.timeLeft ? '剩余时长' : '截止日期'}}</div>
			</div>
			<div class="time" v-if="info.made_cycle != '' && info.made_cycle != null">
				<div class="time_t">{{ info.made_cycle }}</div>
				<div class="time_b">制作工期</div>
			</div>
			<div class="time" v-if="info.totalCount>0">
				<div class="time_t">{{ info.leftMadeCount }}</div>
				<div class="time_b">剩余可定制</div>
			</div>
		</div>
	</div>
	<div class="page_iteminfo" v-if="info && info.tradesman">
		<div class="jiangren">
			<div class="con">
				<div class="con_info clearfix" @click="toTradesmanDetail(info.tradesman)">
					<van-image class="thumb f-l" fit="cover" :src="info.tradesman.thumb ? ( $publicData.withHttpStart(info.tradesman.thumb) ? info.tradesman.thumb : imageUrl+info.tradesman.thumb) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
					<div class="f-l con_info_r">
						<div class="name slh_s">{{ info.tradesman.nickname }}</div>
						<div class="tag slh_s" v-if="info.tradesman.data && info.tradesman.data.auth_company">{{ info.tradesman.data.auth_company }}</div>
					</div>
				</div>
				<div :class="info.is_attention==1 ? 'guanzhu': 'guanzhu guanzhu_no'" @click="attentionTadesmanClick(info.tradesman)">{{ info.is_attention==1?'已关注':'关注' }}</div>
			</div>
		</div>
	</div>
	<div class="info" v-if="info">
		<div class="jieshao" v-html="info.content"></div>
	</div>
	<!-- 讨论 收藏 点赞 -->
    <div class="comments">
        <div class="actions" v-if="info">
            <div class="action comment">
                <div class="text" @click="toCommentFir">讨论{{'('+ info.first_comment_num +')'}}</div>
            </div>
            <div :class="info.is_attentioncustomized ? 'action collect collected' : 'action collect'" @click="clickCollect(info)">
                <div class="text">收藏{{'('+ info.attention_num +')'}}</div>
            </div>
            <div :class="info.is_click ? 'action like liked' : 'action like'" @click="clickLike(info)">
                <div class="text">点赞{{'('+ info.click_num +')'}}</div>
            </div>
        </div>
    </div>
	<!-- 讨论内容 -->
    <div class="haserji" >
        <div class="comment" :style="pinglun_status?'':'padding-bottom:1.33rem'">
            <div class="con" v-for="(item,index) in commentArr" :key="index">
                <div class="con_top clearfix">
                    <div class="f-l thumb">
                        <img :src="item.userdata.thumb ? ( $publicData.withHttpStart(item.userdata.thumb) ? item.userdata.thumb : imageUrl+item.userdata.thumb ) : $publicData.defaultTouxiang" alt="" class="thumb" />
                    </div>
                    <div class="f-l con_top_r">
                        <span class="user_name">{{ item.userdata.nickname ? item.userdata.nickname : item.userdata.username ? $publicData.formatPhone(item.userdata.username) : ''}}</span>
                        <span class="time">{{ item.created_at }}</span>
                    </div>
                </div>
                <div class="con_nr">
                    <div class="yiji_txt" @click="toCommentSec(item)">{{ item.content }}</div>
                    <div class="image_back" v-if="item.attr && item.attr.length > 0">
                        <van-image class="photo" v-for="(imgUrl,index) in item.attr" :key="index" :src="imgUrl" fit="cover" @click="showCommentImages(item.attr,index)"/>
                    </div>
                    <!-- 二级回复 -->
                    <div class="huifu" v-if="item.second_num != 0">
                        <div class="item clearfix" v-for="huifu in (item.show_more_second ? item.customizedcomment.slice(0,limited_num) : item.customizedcomment)" :key="huifu.id">
                            <div class="user_name f-l" v-if="huifu.userdata">
                                {{ huifu.userdata.nickname ? huifu.userdata.nickname + ":" : huifu.userdata.username ?  $publicData.formatPhone(huifu.userdata.username) + ":" : '' }}{{ huifu.content }}
                            </div>
                            <!-- <div class="erji_txt f-l slh_s"></div> -->
                        </div>
                        <div class="total item" v-if="item.show_more_second" @click="secondMore(item,index)">共有{{item.second_num}}条回复&nbsp;&gt;</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="morecomment" v-if="show_more" @click="loadMore">加载更多</div> -->
    </div>
	<!-- 讨论 -->
	<div class="pinglun" :style="pinglun_status ? 'opacity: 1;' : 'opacity: 0;' ">
		<div class="filed">
			<van-field v-model="comment_text" :placeholder="placeholder" ref="field" @blur="pinglun_status=false"/>
		</div>
		<div class="action" @click="toComment">讨论</div>
	</div>
	<!-- <van-popup class="pinglunwrap" v-model="showpop" position="bottom" round>
		<div class="ping_t">
			<van-icon name="cross" @click="showpop = false" />
			<div class="title">发表讨论</div>
			<div class="send" @click="toComment">发送</div>
		</div>
		<div class="pingnr">
			<van-field v-model="comment_text" type="textarea" placeholder="说点什么吧~" />
			<div class="send">写下你的想法...</div>
		</div>
	</van-popup> -->
	<!-- 底部 -->
	<div class="bottom">
		<!-- showpop = true -->
		<div class="bottom_l" @click="bindPinglun">
			<div class="ping">讨论</div>
		</div>
		<div class="bottom_r">
			<div :class="(info != null && info.is_buy==1 && pay_status != 2) ? 'ping liao' : 'buy' " @click="serveClick">聊一聊</div>
			<div :class="isEnd?'buy_no':'buy'" @click="payAction" v-if="info != null && info.is_buy==1 && pay_status != 2">{{info.pay_type==2?'支付全额':'支付定金'}}</div>
		</div>
	</div>
	<!-- 支付定金弹框 -->
	<van-overlay :show="showSettle" class-name="overlay">
		<div class="dingjin">
			<div class="top"></div>
			<div class="nr">
				<div class="nr_t">
					<img :src="publicPath+'statics/images/dingzhi/guize.png'" alt="" class="tu">
				</div>
				<div class="nr_m">
					<div class="">1、“定金”是平台根据匠人定制最终售价的一定比例所收首款，将作为本定制单交易开始的押金，交易达成后自动抵扣为订单费用；</div>
					<div class="">2、待定制作品完成后，平台将匠人按照用户需求匠心打造的作品照片发送至用户，并请用户进行“验收”；</div>
					<div class="">3、验收完成后，用户在平台进行“支付尾款”操作，如无特殊情况，平台将督促匠人于48小时内寄送出定制作品至用户地址接收处；</div>
					<div class="">4、用户收到定制作品后，如无质量问题，在平台进行“确认收货”操作，最终完成订单。</div>
				</div>
				<div class="nr_b">
					<div class="btn" @click="showSettle = false">取消</div>
					<div class="btn submit" @click="toSettle">确定</div>
				</div>
			</div>
		</div>
	</van-overlay>
    <van-image-preview v-model="showImage" :images="attrImages" :start-position="position" ref="attrPreView">
    </van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            id: this.$route.query.id,
            info: null,
            pay_status: this.$route.query.pay_status, // 定金支付状态 0未支付 1支付中 2支付成功
            commentArr: [], // 讨论
            comment_text: null, // 讨论内容
			placeholder: '说点什么吧~', // 讨论占位符
			commentItem: null, // 二级讨论
			limited_num: 3, // 二级讨论隐藏条数限制
			playerId: 'aliplayer_' +
                    Math.random()
                        .toString(36)
                        .substr(2),
			instance: null,
			playStyle: {
				width: '100%',
				height: '6.57rem',
				display: 'none',
			},
            playerId: 'aliplayer_' +
                Math.random()
                .toString(36)
				.substr(2),
			player: null,   // 初始化的播放器
			bannerTime: '3000',
			showpop: false, // 是否自动聚焦
			pinglun_status: false, // 是否聚焦
			showSettle: false, // 支付定金弹框
            isSendingMessage: false,
            showImage: false,
            attrImages: [],
            position: 0,
            isEnd: false
        };
    },
	// created
    created: function () {
        var that = this;
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '定制详情',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getDetail()
                } else {
                    this.token = ''
                    this.getDetail()
                }

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA,
                        detail: that.info.descript ? that.info.descript : '',
                        url: url,
                        platFormType: '',
                        image: that.info.attrShow ? that.$publicData.ossImage + that.info.attrShow[0] : that.$publicData.domain + that.$publicData.shareDefaultIcon,
                        isMiniProgram: "1",
                        miniUserName: that.$publicData.miniUserName,
                        path: 'pages/detail/index?id='+that.id
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
			// function (res) {
            //     // console.log('123',res)

            //     // console.log('this.info111,',that.info)
            // }
            this.getDetail()
        }
	},
    methods: {
        getDetail() {
            var that = this
            var params = {
                id: this.id,
                token: this.token
            }
            this.$api.dingzhi.detail(params).then(res => {
                if (res.code == 200) {
                    // this.info = res.result
					// console.log('this.info',this.info)
                    that.isEnd = false
					var info = res.result;
					// 已定制数 = 真实定制 + 假数据
					var hadMadeCount = null
					var leftMadeCount = null
					var percentage = null
					var totalCount = info.accept_order_count ? info.accept_order_count : 0
					var realCount = info.order_count ? info.order_count : 0
					var falseCount = info.false_data ? info.false_data : 0
					if(parseInt(realCount) + parseInt(falseCount) <= totalCount){
						hadMadeCount = parseInt(realCount) + parseInt(falseCount)
						leftMadeCount = totalCount - realCount - falseCount
					}else{
						hadMadeCount = totalCount
						leftMadeCount = 0
					}
					if(totalCount > 0){
						percentage = Math.floor((hadMadeCount / totalCount) * 100)
					}else{
						percentage = 0
					}
					info.leftMadeCount = leftMadeCount
					info.hadMadeCount = hadMadeCount
                    info.percentage = percentage
                    info.totalCount = totalCount
					// 匠人关注状态
					info.tradesman.is_attention = res.result.is_attention
					// 剩余时长 以'天'计
					if(res.result.end_at){
						var endTimestamp = Date.parse(that.getTimes(res.result.end_at))
						var currentTimestamp = Date.parse(new Date())
						// console.log('结束时间戳',endTimestamp)
						// console.log('当天时间戳',currentTimestamp)
						info.timeLeft = that.$publicData.intervalTime(currentTimestamp,endTimestamp)
					}else{
						info.timeLeft = false
					}
					// 处理富文本
					info.content = info.content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match, $1,$2,$3){
						if(/^http/.test($2)){
							return $1 +$2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					});
					// console.log("富文本",info.content)
					that.info = info;
					// 讨论
					var list = res.result.comment
					for(var i in list){
						var second = list[i].customizedcomment
						if(second && second.length != 0){
							list[i].second_num = second.length
							if(second.length > that.limited_num){
								list[i].show_more_second = true
							}else{
								list[i].show_more_second = false
							}
						}else{
							list[i].second_num = 0
						}
					}
					
					that.commentArr = list
                    // console.log('this.info=====', this.info)
					// 初始化播放器
					if(info.video_type==0 && info.other_video_url){
                        setTimeout(() => {
                            that.setPlayer()
                        }, 500);
						
                        that.bannerTime = ''
					} else if (info.video_type==1 && info.video_url) {
                        setTimeout(() => {
                            that.setPlayer()
                        }, 500);
                        // that.setPlayer()
                        that.bannerTime = ''
                    }
                    if (info.end_at && info.end_at != undefined && info.end_at != '') {
                        var new_date = new Date(); //新建一个日期对象，默认现在的时间
                        var old_date = new Date(info.end_at+" 23:59:59"); //设置过去的一个时间点，"yyyy-MM-dd HH:mm:ss"格式化日期
                        console.log('old_date:',old_date)
                        var difftime = new_date - old_date; //计算时间差
                        console.log('difftime:',difftime)
                        if (difftime > 0) { // 已到截止时间
                            Toast('该定制已到截止日期')
                            that.isEnd = true
                        }
                    }
                    
                    // 调起 获取微信分享参数函数
                    that.getShareData()
                }
            })
        },
        showCommentImages(attr,index) {
            this.showImage = true
            this.attrImages = attr
            this.position = index
        },
        payAction() {
            if (this.isEnd) {
                Toast('该定制已到截止日期，请联系匠人进行购买！')
                return
            }
            if (this.info.pay_type == 2) {
                this.toSettle()
            } else {
                this.showSettle = true
            }
        },
        toSettle() {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/dingzhi/settle?id=' + this.id + '&type=1'
                                }
                            }
                            this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    }
                );
            } else if (userAgent.indexOf('MicroMessenger') != -1) {// 在微信中
                console.log('MicroMessenger')
                wx.miniProgram.getEnv(function(res) {
                    if (res.miniprogram) {
                        // 走在小程序的逻辑
                        Toast('请在公众号中搜索“时代记忆”进行购买')
                    } else {
                        // Toast('不在在微信中小程序')
                        // 验证是否登录
                        if (!that.$store.getters.token) {
                            localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
                            that.$router.push({
                                path: '/login',
                            })
                            return
                        }
                        that.$router.push({
                            path: '/dingzhi/settle',
                            query: {
                                id: that.id,
                                type: 1
                            }
                        })
                        // 走不在小程序的逻辑
                    }
                })
                return
            } else {
                // 验证是否登录
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
                    path: '/dingzhi/settle',
                    query: {
                        id: this.id,
                        type: 1
                    }
                })
            }
        },
        serveClick() {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            token: this.token,
                            uuid: that.info.uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo);
                            }
                        })
                    }
                });
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
                    path: '/tradesman/chat',
                    query: {
                        uuid: this.info.uuid
                    }
                })
                // this.$router.push({
                //     path: '/system/develop'
                // })
            }
        },
        toAppServe(tradesmanInfo) {
            console.log(tradesmanInfo)
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: tradesmanInfo.tradesmans.thumb,
                    toName: this.info.tradesman.nickname,
                    toUUID: this.info.tradesman.uuid,
                    toPhone: tradesmanInfo.tradesmans.data.phone,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            console.log(params)
            this.$bridge.callhandler("sdjy://public/chat", params, (data) => {

            });
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            // console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.descript ? that.info.descript : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.attrShow ? that.imageUrl + that.info.attrShow[0] : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
        // 讨论
        toComment() {
            console.log('toComment')
            if (this.isSendingMessage == true) {
                return
            }
            this.isSendingMessage = true
            if (!this.comment_text) {
                this.$toast('请填写讨内容');
                return;
            }
            
            var params = {
                token: this.token,
                content: this.comment_text,
                custom_made_id: this.info.id
            }
            if (this.commentItem) {
                params.pid = this.commentItem.comment_id
            }
            
            this.$api.dingzhi.comment(params).then(res => {
                if (res.code == 200) {
                    this.$toast('讨论成功')
					this.comment_text = ''
					this.showpop = false
					this.pinglun_status = false
                    this.getDetail()
                    this.commentItem = null
                    this.placeholder = ''
                    setTimeout(() => {
                        this.isSendingMessage = false
                    }, 1000);
                    
                }
            })
		},
		// 二级讨论
        toCommentSec(item) {
            console.log('二级讨论', item)
			var that = this
			that.pinglun_status = true
			// that.$refs.field.focus()
            that.commentItem = item
            that.placeholder = '回复' + (item.userdata.nickname ? item.userdata.nickname : item.userdata.username)
		},
		// 二级讨论加载更多
        secondMore(item,index) {
			item.show_more_second = !item.show_more_second
			this.$set(this.commentArr,index,item)
		},
		// 一级讨论, 清掉已选二级回复人
		toCommentFir(){
			var that = this
			that.commentItem = null
			that.placeholder = null
		},
		// 收藏
		clickCollect(item) {
            var params = {
                token: this.token,
                custom_made_id: item.id
            }
            this.$api.dingzhi.attention(params).then(res => {
                if (res.code == 200) {
					this.$toast(res.message);
					this.getDetail()
                }
            })
		},
		// 点赞
		clickLike(item) {
            var params = {
                token: this.token,
                custom_made_id: item.id
            }
            this.$api.dingzhi.like(params).then(res => {
                if (res.code == 200) {
					this.$toast(res.message)
					this.getDetail()	
                }
            })
		},
		// 播放器
		setPlayer() {
			var that = this
			console.log('调了吗====',that.playerId)
			console.log('=====',$('#'+that.playerId))
            that.playStyle.display = 'block';
            var videoUrl = ''
            if(that.info.video_type==0 && that.info.other_video_url){
				videoUrl = that.info.other_video_url
			} else if (that.info.video_type==1 && that.info.video_url) {
                videoUrl = that.$publicData.domain + '/' + that.info.video_url
            }
            that.instance = new Aliplayer({
                    id: that.playerId,
                    source: videoUrl,
                    width: '100%',
                    height: that.playStyle.height,
					autoplay: true, // 是否自动播放
                    isLive: false,
                    rePlay: false,
                    playsinline: true,
                    preload: true,
                    // controlBarVisibility: "hover",
                    // useH5Prism: true,
                    skinLayout: [{
                            name: "bigPlayButton",
                            align: "blabs",
                            x: 30,
                            y: 80
                        },
                        {
                            name: "H5Loading",
                            align: "cc"
                        },
                        {
                            name: "infoDisplay"
                        },
                        {
                            name: "tooltip",
                            align: "blabs",
                            x: 0,
                            y: 56
                        },
                        {
                            name: "thumbnail"
                        },
                        {
                            name: "controlBar",
                            align: "blabs",
                            x: 0,
                            y: 0,
                            "children": [
                                // {
                                //     "name": "progress",
                                //     "align": "blabs",
                                //     "x": 0,
                                //     "y": 44
                                // },
                                // {
                                //     "name": "playButton",
                                //     "align": "tl",
                                //     "x": 15,
                                //     "y": 12
                                // },
                                // {
                                //     "name": "timeDisplay",
                                //     "align": "tl",
                                //     "x": 10,
                                //     "y": 7
                                // },
                                // {
                                //     "name": "fullScreenButton",
                                //     "align": "tr",
                                //     "x": 10,
                                //     "y": 12
                                // },
                                // {
                                //     "name": "volume",
                                //     "align": "tr",
                                //     "x": 5,
                                //     "y": 10
                                // }
                            ]
                        }
                    ],
                    x5LandscapeAsFullScreen: false,
                    // x5_type:'h5',
                    showBarTime: 5000,
                    // controlBarVisibility: "always",
                    // x5_fullscreen: true,
                    x5_video_position: "bottom",
                    // "x5_orientation":"landscape",
                },
                function (player) {
                    that.player = player;
                    console.log('The player is created');
                    // $('.prism-volume').before("<i class='control_btn'></i>");
                    $("video").attr('x5-video-player-type', 'h5');
                    // $('.control_btn').on('click', function () {
                    //     if (!$('.prism-player').hasClass('fullScreen')) {
                    //         $('.prism-player').addClass('fullScreen');
                    //         $('.living_tabs').addClass('fullScreen');
                    //     } else {
                    //         $('.prism-player').removeClass('fullScreen');
                    //         $('.living_tabs').removeClass('fullScreen');
                    //     }
                    // });
                    player.on("error", function (e) {
                        $(".prism-ErrorMessage").hide();
                        player.show_video = true;
                    })
                    player.on("ended", function (e) {
                        
                        player.play()
                    })
                    // player.on("ended", function (e) {
                        
                    //     player.play() = true;
                    // });
                }
            );
		},
		// 关注匠人 对App和H5做判断
		attentionTadesmanClick(tradesman){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionTadesman(tradesman);
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionTadesman(tradesman);
			}
		},
		// 关注匠人
        attentionTadesman(tradesman) {
            var params = {
                token: this.token,
                tradesman_id: tradesman.id,
                type: this.info.is_attention ? 2 : 1  // 1关注 2取消关注
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    this.$toast(res.message)
                    this.getDetail()
                } else {
                    this.$toast(res.message)
                }
            })
		},
		// 去匠人详情
		toTradesmanDetail(tradesman) {
            console.log('111:',tradesman)
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: tradesman.id
                    }
                })
            }
		},
		// 讨论触发调起软键盘
		bindPinglun(){
			var that = this
			that.pinglun_status = true
			that.$refs.field.focus()
		},
		// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15'
		getTimes(strdate){
			var arr = strdate.split(/[- : \/]/);
			var date = new Date(arr[0], arr[1] - 1, arr[2],24,0,0);
			return date;
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
